/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import { helper as buildHelper } from '@ember/component/helper';
import { ALL_SEAT_LABELS } from 'embercom/lib/settings/seats/constants';

export default buildHelper(function ([seatType, _]) {
  return ALL_SEAT_LABELS[seatType];
});
